<div class="committed-exchanges-container container-fluid">
  <h3>Committed Exchanges</h3>

  <ng-container *ngIf="committedExchangeResponseError">
    <invd-fm-message-alerts
      [messageTitle]="messageTitle"
      [messageBody]="messageBody"
    ></invd-fm-message-alerts>
  </ng-container>

  <ng-container *ngIf="!committedExchangeResponseError">
    <div class="fm-cdx-table">
      <table class="fm-cdx-table__static">
        <thead>
          <tr class="th_row">
            <th class="th_column th_icon">Edit</th>
            <th class="th_column th_icon">Cancel</th>
            <th class="th_column th_sortable-column sortable-column-confirmationNumber">
              <span>Confirm #</span>
              <a
                class="th_sortable-column__item column-name"
                (click)="sortByGridByColumnName('exchangeConfirmationNumber')"
              >
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'exchangeConfirmationNumber'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'exchangeConfirmationNumber'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
            <th class="th_column th_sortable-column sortable-column-dealNumber">
              <span>Deal/Trust #</span>
              <a
                class="th_sortable-column__item column-name"
                (click)="sortByGridByColumnName('dealNumber')"
              >
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'dealNumber'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'dealNumber'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
            <th class="th_column th_sortable-column sortable-column-dealType">
              <span>Deal Type</span>
              <a
                class="th_sortable-column__item column-name"
                (click)="sortByGridByColumnName('displayDealType')"
              >
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'displayDealType'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'displayDealType'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
            <th class="th_column">
              Bonds <br />
              Exchanged
            </th>
            <th class="th_column th_sortable-column sortable-column-settlementDate">
              <span>Settlement</span>
              <a
                class="th_sortable-column__item column-name"
                (click)="sortByGridByColumnName('exchangeSettlementDate')"
              >
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'exchangeSettlementDate'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'exchangeSettlementDate'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
            <th class="th_column th_column--is-numeric">
              Orig. Balance <br />
              Exchanged
            </th>
            <th class="th_column th_sortable-column sortable-column-dealerName">
              <span>DEALER</span>
              <a
                class="th_sortable-column__item column-name"
                (click)="sortByGridByColumnName('dealerName')"
              >
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'dealerName'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'dealerName'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="td_row"
            *ngFor="
              let commitExchange of commitExchangesData | paginate: config;
              let j = index;
              trackBy: trackByIdentity
            "
          >
            <td class="td_cell td_icon">
              <button
                type="button"
                class="committed-exchange-icon button-takedown--transparent"
                [disabled]="
                  commitExchange.isEditable === 'false' ||
                  !enableEdit ||
                  commitExchange.allowCancel === 'false'
                "
                (click)="editExchange(commitExchange)"
              >
                <i class="fa fa-pencil-square-o edit-exchange-icon-enable"></i>
              </button>
            </td>
            <td class="td_cell td_icon">
              <button
                [disabled]="commitExchange.allowCancel === 'false'"
                (click)="cancelCommitExchange(commitExchange)"
                type="button"
                class="committed-exchange-icon button-takedown--transparent"
              >
                <i class="fa fa-times-circle edit-exchange-icon-enable"></i>
              </button>
            </td>
            <td class="td_cell" (click)="retrieveExchangeData((config.currentPage - 1) * 50 + j)">
              <a>{{ commitExchange?.exchangeConfirmationNumber }}</a>
            </td>
            <td class="td_cell">{{ commitExchange?.dealNumber }}</td>
            <td class="td_cell deal-type--min-width">{{ commitExchange?.displayDealType }}</td>
            <td class="td_cell">{{ commitExchange?.bondsExchanged }}</td>
            <td class="td_cell">
              {{ commitExchange?.exchangeSettlementDate | date: 'MM/dd/yyyy' : 'America/New_York' }}
            </td>
            <td class="td_cell td_cell--is-numeric">
              {{ commitExchange?.origBalExchanged | currency: 'USD' : 'symbol' : '1.0' }}
            </td>
            <td class="td_cell">{{ commitExchange?.dealerName }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination-template
      #p="paginationApi"
      [id]="config.id"
      (pageChange)="config.currentPage = $event"
      *ngIf="displayPagination"
    >
      <nav
        aria-label="Page navigation"
        class="committed-exchanges-pagination d-flex justify-content-end"
      >
        <ul class="pagination">
          <li class="page-item pagination-previous" [class.disabled]="p.isFirstPage()">
            <a class="page-link" (click)="p.previous()">
              <span aria-hidden="true">PREV</span>
            </a>
          </li>

          <li
            class="page-item"
            *ngFor="let page of p.pages; trackBy: trackByIdentity"
            [class.active]="p.getCurrent() === page.value"
          >
            <a
              class="page-link"
              [ngClass]="{ ellipse: page.label === '...' }"
              (click)="p.setCurrent(page.value)"
              *ngIf="p.getCurrent() !== page.value"
            >
              <span>{{ page.label }}</span>
            </a>
            <a class="page-link" *ngIf="p.getCurrent() === page.value">
              <span>{{ page.label }}</span>
            </a>
          </li>

          <li class="page-item pagination-next" [class.disabled]="p.isLastPage()">
            <a class="page-link" (click)="p.next()">
              <span aria-hidden="true">NEXT</span>
            </a>
          </li>
        </ul>
      </nav>
    </pagination-template>
  </ng-container>
</div>

<div class="cancel-exchange-modal-window" *ngIf="cancelExchangeModalWindow.show">
  <div class="panel panel-default">
    <button
      type="button"
      class="close float-end"
      aria-label="Close"
      (click)="cancelExchangeModalWindow.show = false"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <h4>Are you sure you want to cancel this exchange?</h4>
      <p>
        You are about to cancel the exchange from <br />
        Deal {{ cancelExchangeModalWindow.commitExchange?.dealNumber }} (confirmation #{{
          cancelExchangeModalWindow.commitExchange?.exchangeConfirmationNumber
        }}).
      </p>
      <p>
        This action can not be undone. <br />
        To get it back you must request a new exchange.
      </p>
      <button class="button fm-tertiary-button" (click)="cancelExchangeModalWindow.show = false">
        NO
      </button>
      <button
        class="button fm-primary-button"
        #exchangeCancelledOnButtonClick
        (click)="callCancelExchangeService(cancelExchangeModalWindow.commitExchange)"
      >
        YES
      </button>
    </div>
  </div>
</div>

<div class="cancel-exchange-modal-window" *ngIf="cancelExchangeModalWindow.showCancelConfirmation">
  <div class="panel panel-default">
    <button
      type="button"
      class="close float-end"
      aria-label="Close"
      (click)="cancelExchangeModalWindow.showCancelConfirmation = false"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-body">
      <i class="fa fa-check-circle-o check-icon"></i>
      <h4>Your exchange is now cancelled.</h4>
      <button
        class="button fm-primary-button"
        (click)="cancelExchangeModalWindow.showCancelConfirmation = false"
      >
        Close
      </button>
    </div>
  </div>
</div>

<div class="edit-dealer-trader-modal-window" *ngIf="showDealerTraderModal">
  <div class="panel panel-default">
    <button
      type="button"
      class="close float-end"
      aria-label="Close"
      (click)="showDealerTraderModal = false"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <h5 class="modal-title">Select Dealer/Trader</h5>
    <div class="panel-body">
      <form class="dealer-trader-form" #f="ngForm" [formGroup]="requestExchangeForm">
        <!--******************************* Dealer Dropdown *******************************-->
        <h5>Dealer</h5>
        <div class="custom-select">
          <select
            [ngModel]="selectedDealer"
            formControlName="dealerControl"
            (ngModelChange)="onDealerSelect($event)"
          >
            <option disabled [ngValue]="null">Select dealer</option>
            <option *ngFor="let dealer of dealers; trackBy: trackByIdentity" [ngValue]="dealer">
              {{ dealer.dealerName }}
            </option>
          </select>
        </div>
        <!--******************************* Dealer Dropdown *******************************-->

        <!--******************************* Approved Trader Dropdown *******************************-->
        <ng-container *ngIf="selectedDealer == null">
          <h5 class="trader-pos">Approved Trader</h5>
          <div class="custom-select">
            <select
              class="custom-select"
              formControlName="traderControl"
              [ngModel]="selectedAssociatedTrader"
              (ngModelChange)="onTraderSelect($event)"
            >
              <option disabled [ngValue]="null">Select Approved Trader</option>
            </select>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedDealer != null">
          <h5 class="trader-pos">Approved Trader</h5>
          <div class="custom-select">
            <select
              class="custom-select"
              formControlName="traderControl"
              [ngModel]="selectedAssociatedTrader"
              (ngModelChange)="onTraderSelect($event)"
            >
              <option disabled [ngValue]="null">Select Approved Trader</option>
              <option
                *ngFor="let trader of selectedDealer.traders; trackBy: trackByIdentity"
                [ngValue]="trader"
              >
                {{ trader.traderFirstName + ' ' + trader.traderLastName }}
              </option>
            </select>
          </div>
        </ng-container>

        <!--******************************* Approved Trader Dropdown *******************************-->
      </form>

      <div class="footer">
        <button
          class="button fm-primary-button"
          (click)="submitTraderDetails()"
          [disabled]="!(selectedDealer && selectedAssociatedTrader)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
